<template>
    <div class="filters-panel text-black" :style="panelStyle">
        <header class="header">
            <span v-if="currentLevel" @click="setLevel(0)"><img class="icon chevron-icon-left" src="../assets/chevron-right-icon.svg"></span>
            <span v-else>Filters</span>
            <img @click="close" class="icon x-icon" src="../assets/x-icon.svg" />
        </header>
        <ul class="selections checkboxes" v-if="currentLevel">
            <li v-for="(item,index) in currentSelections" :key="item.title">
                <check-box @click.native="toggleItem(index)" :checked="item.selected" :all="!index"></check-box>
                <span>{{ item.title }}</span>

            </li>
        </ul>
        <ul class="selections" v-else>
            <li v-for="(item,index) in currentSelections" :key="item.title">
                <span>{{ item.title }}</span>
                <span class="text-primary link" @click="setCategory(index)">{{ item.selection }} <img class="icon chevron-icon" src="../assets/chevron-right-icon.svg" /></span>
            </li>
        </ul>
        <footer class="footer" v-if="currentLevel">
            <span class="text-primary"></span>
            <button class="button" @click="setLevel(0)">Select</button>
        </footer>
        <footer class="footer" v-else>
            <span class="text-primary link" @click="reset">Reset</span>
            <button class="button" :data-inactive="!hasChanges" @click="apply">Apply</button>
        </footer>

    </div>
</template>

<script>
    import CheckBox from "./CheckBox";
    export default {
        name: "filters-panel",
        components: {CheckBox},
        props: {
            left: {
                default: "0em"
            },

            top: {
                default: "0em"
            },

            width: {
                default: "6em"
            }
        },
        data: function () {
            return {
                isInactive: true,
                hasChanges: false,
                title: "Filters",
                currentLevel: 0,
                currentCategory: 0,
                selections: [
                        { title: "Employment Status", selection: "All", selections: [
                                { title: "All", selected: true },
                                { title: "Full-time (active)", selected: true },
                                { title: "Part-time (active)", selected: true },
                                { title: "Terminated", selected: true },
                                { title: "Inactive", selected: true },
                                { title: "Unknown (active)", selected: true },
                            ]
                        },
                        { title: "Class", selection: "All", selections: [
                                { title: "All", selected: true },
                                { title: "OWNERS", selected: true },
                                { title: "EMPLOYEES", selected: true },
                            ]
                        }
                    ]
                ,


            }
        },
        methods: {
            close: function(){
                this.setLevel(0);
                this.$emit('close');
            },

            apply: function(){
                this.hasChanges = false;
                this.$emit('apply', this.selections);
            },

            reset: function(){
                this.selections.forEach((selection)=>{

                    selection.selections.forEach((item)=>{
                        item.selected = true;
                    })

                    selection.selection = "All";

                })

                this.hasChanges = true;
            },

            setLevel: function(level){
                this.currentLevel = level;
            },

            setCategory: function(index){
                console.log("set Category ", index);
                this.currentCategory = index;
                this.currentLevel = 1;
            },

            toggleItem: function(index){
                console.log("toggle", index);
                this.hasChanges = true;
                let item = this.selections[this.currentCategory].selections[index];

                let selected = [];

                if(index){
                    item.selected = !item.selected;
                    if(!item.selected){
                        this.selections[this.currentCategory].selections[0].selected = false;
                    }

                    this.selections[this.currentCategory].selections.forEach((selection)=>{
                        if(selection.selected){
                            selected.push(selection.title);
                        }
                    })
                }else{
                    item.selected = !item.selected;
                    this.selections[this.currentCategory].selections.forEach((selection)=>{
                        selection.selected = item.selected;
                        if(selection.selected){
                            selected.push(selection.title);
                        }
                    })
                }


                if(selected.length){

                    if(selected.length < this.selections[this.currentCategory].selections.length){
                        if(selected.length == 1){
                            this.selections[this.currentCategory].selection = selected[0];
                        }else{
                            this.selections[this.currentCategory].selection = selected.length + " Items";
                        }

                    }else{
                        this.selections[this.currentCategory].selection = "All"
                    }
                }else{
                    this.selections[this.currentCategory].selection = "";
                }


            }
        },
        computed: {
            panelStyle: function(){
                return {
                    width: this.width,
                    top: this.top,
                    left: this.left
                }
            },


            currentSelections: function(){

                if(this.currentLevel){
                    return this.selections[this.currentCategory].selections;

                }else{
                    return this.selections;
                }
            }

        }
    }
</script>

<style scoped>


    .filters-panel {
        font-size: 0.9vw;
        position: absolute;

        background-color: white;
        box-shadow: 0 2px 5px rgba(0,0,0,0.3);
    }

    .header {
        display: flex;
        justify-content: space-between;
        padding: 1em 1em;
    }

    .footer {
        display: flex;
        justify-content: space-between;
        align-items: center;

        border-top: 1px solid #D8D8D8;
        padding: 0.5em 1em;


    }

    .selections {
        margin: 0;
        margin-bottom: 0.75em;
        padding: 0;
        list-style: none;
    }

    .selections li {
        margin: 0;
        padding: 0.75em 1em;
        display: flex;
        justify-content: space-between;
        align-items: center;


    }

    .selections.checkboxes li {
        margin: 0;
        padding: 0.75em 1em;
        display: flex;
        justify-content: flex-start;
        align-items: center;


    }

    .icon {
        height: 1em;
    }

    .icon.chevron-icon {
        height: 0.9em;
        margin-left: 0.5em;
    }

    .icon.chevron-icon-left {
        transform: rotate(180deg);
    }

    .check-box {
        margin-right: 0.75em;
        margin-left: 0.5em;
    }

</style>